import { Component, OnInit } from '@angular/core';
import { ReservationDto, Dictionary } from '../../models';
import { ReservationRetailService, CommonService } from '../../services';
import { MessageService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import * as globals from '../../globals';

@Component({
    selector: 'app-reservation-retail',
    templateUrl: './reservation-retail.component.html',
    styleUrls: ['./reservation-retail.component.css']
})
export class ReservationRetailComponent implements OnInit {
    reservation: ReservationDto = new ReservationDto();
    carparks: SelectItem[];
    pl = globals.pl;

    constructor(
        private reservationService: ReservationRetailService,
        private messageService: MessageService,
        private commonsService: CommonService
    ) { }

    ngOnInit() {
        this.commonsService.getCarParks().subscribe(
            carparks => this.carparks = carparks.map(
                c => {
                    return { label: c.name, value: c.id };
                }
            ),
            error => {
                console.error(error);
            }
        );
    }

    addReservation() {
        console.log(this.reservation);
        if (this.reservation.carparkId == null || !this.reservation.dateFrom || !this.reservation.dateUntil || !this.reservation.email) {
            this.messageService.add({ severity: 'error', summary: 'Wymagane pola', detail: 'Pola z gwiazką (*) są wymagane.' });
            return;
        }
        this.reservation.sendEmail = true;
        this.reservationService.saveReservation(this.reservation).subscribe(
            () => {
                this.messageService.add({ severity: 'success', summary: 'Zapisano rezerwację', detail: '' });
                this.reservation = new ReservationDto();
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Błąd zapisu rezerwacji', detail: error });
            }
        );
    }
}
